export const formatDate = (dateProp, type = 'EEE dd MMM') => {
  const date = new Date(dateProp);

  if (type === 'EEE dd MMM') {
    return date
      .toLocaleDateString('en-US', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
      .replace(',', '');
  } else if (type === 'MM/DD/YYYY') {
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
  }
};
